var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carouselShow)?_c('ConstomSwiper',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"statusConfig":_vm.statusConfig,"swiperList":_vm.computedSwipeOptions},on:{"onItem":_vm.onItem}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }